export const hrPageActions = {
    MOVE_TO_SHORTLISTED: 'Hr_Shortlisted',
    MOVE_TO_REJECTED: 'Hr_Rejected',
    MOVE_TO_SELECTED: 'Hr_Selected',
    MOVE_TO_PENDING: 'Hr_Pending',
}